var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-edit-content q-select", class: { display: !_vm.edit } },
    [
      _vm.edit
        ? [
            _c(
              "draggable",
              {
                ref: "drag",
                attrs: { options: { handle: ".sort-item", animation: 200 } },
                on: {
                  update: _vm.moved,
                  start: function ($event) {
                    _vm.drag = true
                  },
                  end: function ($event) {
                    _vm.drag = false
                  },
                },
                model: {
                  value: _vm.value.detail.list,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.detail, "list", $$v)
                  },
                  expression: "value.detail.list",
                },
              },
              _vm._l(_vm.value.detail.list, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "q-select-item row",
                    attrs: { label: index },
                  },
                  [
                    _c("div", { staticClass: "sort-item" }, [
                      _c("img", {
                        staticStyle: { cursor: "move" },
                        attrs: {
                          width: "8",
                          src: "https://cnstatic01.e.vhall.com/upload/interacts/screen-imgs/202404/4e/00/4e0048314a03b356b433a19a7e41584a9065.png",
                          alt: "",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-icon" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "select-input" },
                      [
                        _c("com-input", {
                          class: { error: item.error },
                          attrs: {
                            placeholder: "请输入选项",
                            "max-length": 100,
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.itemFocus(item)
                            },
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.edit && _vm.value.detail.list.length > 2
                      ? _c(
                          "span",
                          {
                            staticClass: "remove",
                            on: {
                              click: function ($event) {
                                return _vm.delItem(index)
                              },
                            },
                          },
                          [_c("i", { staticClass: "vh-icon-remove-outline" })]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        : [
            !_vm.edit
              ? _c(
                  "vh-select",
                  {
                    staticClass: "quiz-select-container",
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.isPreview || _vm.isReplay,
                      multiple: "",
                      "popper-append-to-body": false,
                      "collapse-tags": "",
                      placeholder: "请选择",
                      size: "small",
                      "popper-class": "vmp-quiz-select",
                    },
                    on: { change: _vm.change },
                    model: {
                      value: _vm.val,
                      callback: function ($$v) {
                        _vm.val = $$v
                      },
                      expression: "val",
                    },
                  },
                  _vm._l(_vm.value.detail.list, function (item, index) {
                    return _c("vh-option", {
                      key: index,
                      attrs: {
                        label: item.value,
                        value: item.key ? item.key : index,
                      },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.edit && _vm.errorTip
              ? _c("div", { staticClass: "error-msg" }, [
                  _vm._v("\n      " + _vm._s(_vm.errorTip) + "\n    "),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }